const storesLocationData = JSON.parse(document.querySelector('[data-location-settings]').innerHTML).stores

if (storesLocationData) {
    let location_check_delay = 0;

    function isCookieSet(value) {
        return document.cookie.split(';').some(function (item) {
            return item.trim().indexOf(value) === 0
        })
    }


    function handleLocationCheck() {
        if (isCookieSet('location_checked')) {
            return;
        }

        fetch('https://shark-app-jxbr8.ondigitalocean.app/api/geoip', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function (res) {
            return res.json()
        }).then(function (geoData) {
            if (geoData.success) {
                const countryCode = geoData.result.country.iso_code;
                const validStoreToDirectTo = storesLocationData.find(store => store.target_countries.split(',').includes(countryCode));

                if (validStoreToDirectTo && validStoreToDirectTo.direct_redirect === true) {
                    const date = new Date(
                        new Date().getTime() + 1000 * 60 * 60 * 24
                    );
                    if (!validStoreToDirectTo.always_redirect) {
                        document.cookie = "location_checked=true;expires=" + date + ";";
                    }
                    window.location.href = validStoreToDirectTo.url;
                }

                if (validStoreToDirectTo) {
                    document.querySelector('[data-location-title').innerHTML = validStoreToDirectTo.title.replace('{{ country }}', geoData.result.country.names["en"]);
                    document.querySelector('[data-location-content').innerHTML = validStoreToDirectTo.content
                    document.querySelector('[data-location-image').src = `https://cdn.shopify.com/static/images/flags/${geoData.result.result.code.toLocaleLowerCase()}.svg`;
                    document.querySelector('[data-location-switcher-display]').style.display = 'block'
                }

                document.querySelector('.location-switcher--cancel').addEventListener('click', function (evt) {
                    evt.preventDefault()
                    document.querySelector('[data-location-switcher-display]').style.display = 'none'
                    const date = new Date(
                        new Date().getTime() + 1000 * 60 * 60 * 24
                    );
                    document.cookie = "location_checked=true;expires=" + date + ";";
                })

                document.querySelector('.location-switcher--confirm').addEventListener('click', function (evt) {
                    evt.preventDefault()
                    const date = new Date(
                        new Date().getTime() + 1000 * 60 * 60 * 24
                    );
                    document.cookie = "location_checked=true;expires=" + date + ";";
                    window.location.href = validStoreToDirectTo.url;
                })
            } else {
                const date = new Date(
                    new Date().getTime() + 1000 * 60 * 60 * 24
                );
                document.cookie = "location_checked=true;expires=" + date + ";";
            }
        }).catch(function (err) {
            console.log("Failed to fetch location data")
        })

    }

    setTimeout(function () {
        handleLocationCheck();
    }, location_check_delay * 1000)
}